import axios from '@/utils/ajax/index'; // 倒入 api
import fileExport from '@/utils/fileExport/index'; // 导出文件 api
// 获取诊所支付相关配置

export const getPayConfig = (params) => {
  return axios({
    url: '/hospitalManage/hospital/getPayConfig',
    method: 'get',
    params,
  });
};
export default {
  getPayConfig,
};
